import React from 'react';
import useInView from '../../hooks/useInView';
import styles from './WorkProcess.module.css';

const steps = [
  {
    number: 1,
    icon: '\u{1F4CB}',
    title: '\u0417\u0430\u044F\u0432\u043A\u0430',
    text: '\u041E\u0441\u0442\u0430\u0432\u044C\u0442\u0435 \u0437\u0430\u044F\u0432\u043A\u0443 \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0438\u043B\u0438 \u0441\u0432\u044F\u0436\u0438\u0442\u0435\u0441\u044C \u0441 \u043D\u0430\u043C\u0438. \u041C\u044B \u043E\u0431\u0441\u0443\u0434\u0438\u043C \u0432\u0430\u0448\u0443 \u0437\u0430\u0434\u0430\u0447\u0443 \u0438 \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0438\u043C \u043E\u043F\u0442\u0438\u043C\u0430\u043B\u044C\u043D\u043E\u0435 \u0440\u0435\u0448\u0435\u043D\u0438\u0435.',
  },
  {
    number: 2,
    icon: '\u{1F4CA}',
    title: '\u0410\u043D\u0430\u043B\u0438\u0437',
    text: '\u041F\u0440\u043E\u0432\u043E\u0434\u0438\u043C \u0434\u0435\u0442\u0430\u043B\u044C\u043D\u044B\u0439 \u0430\u043D\u0430\u043B\u0438\u0437 \u0432\u0430\u0448\u0435\u0439 \u0441\u0438\u0442\u0443\u0430\u0446\u0438\u0438, \u0440\u0430\u0441\u0441\u0447\u0438\u0442\u044B\u0432\u0430\u0435\u043C \u0441\u0442\u043E\u0438\u043C\u043E\u0441\u0442\u044C \u0438 \u0441\u0440\u043E\u043A\u0438, \u0433\u043E\u0442\u043E\u0432\u0438\u043C \u043A\u043E\u043C\u043C\u0435\u0440\u0447\u0435\u0441\u043A\u043E\u0435 \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u0435.',
  },
  {
    number: 3,
    icon: '\u{1F4D1}',
    title: '\u041E\u0444\u043E\u0440\u043C\u043B\u0435\u043D\u0438\u0435',
    text: '\u0411\u0435\u0440\u0451\u043C \u043D\u0430 \u0441\u0435\u0431\u044F \u0432\u0441\u044E \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430\u0446\u0438\u044E: \u043A\u043E\u043D\u0442\u0440\u0430\u043A\u0442\u044B, \u0442\u0430\u043C\u043E\u0436\u0435\u043D\u043D\u044B\u0435 \u0434\u0435\u043A\u043B\u0430\u0440\u0430\u0446\u0438\u0438, \u0441\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u044B, \u0432\u0430\u043B\u044E\u0442\u043D\u044B\u0439 \u043A\u043E\u043D\u0442\u0440\u043E\u043B\u044C.',
  },
  {
    number: 4,
    icon: '\u2705',
    title: '\u0420\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442',
    text: '\u0412\u0430\u0448 \u0442\u043E\u0432\u0430\u0440 \u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D, \u0432\u0441\u0435 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B \u043E\u0444\u043E\u0440\u043C\u043B\u0435\u043D\u044B. \u0412\u044B \u043F\u043E\u043B\u0443\u0447\u0430\u0435\u0442\u0435 \u043F\u043E\u043B\u043D\u044B\u0439 \u043F\u0430\u043A\u0435\u0442 \u0437\u0430\u043A\u0440\u044B\u0432\u0430\u044E\u0449\u0438\u0445 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u043E\u0432.',
  },
];

export default function WorkProcess() {
  const [ref, isVisible] = useInView();

  return (
    <section className={styles.section} ref={ref}>
      <div className={styles.container}>
        <div className={styles.header}>
          <span className={styles.badge}>{'\u041A\u0430\u043A \u043C\u044B \u0440\u0430\u0431\u043E\u0442\u0430\u0435\u043C'}</span>
          <h2 className={styles.title}>{'\u041F\u0440\u043E\u0446\u0435\u0441\u0441 \u0440\u0430\u0431\u043E\u0442\u044B \u0441 \u043D\u0430\u043C\u0438'}</h2>
          <p className={styles.subtitle}>
            {'\u041E\u0442 \u043F\u0435\u0440\u0432\u043E\u0433\u043E \u043E\u0431\u0440\u0430\u0449\u0435\u043D\u0438\u044F \u0434\u043E \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u044F \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u0430 \u2014 4 \u043F\u0440\u043E\u0441\u0442\u044B\u0445 \u0448\u0430\u0433\u0430'}
          </p>
        </div>
        <div className={styles.steps}>
          {steps.map((step, i) => (
            <div
              className={`${styles.step} ${isVisible ? styles.stepVisible : ''}`}
              key={step.number}
              style={{ transitionDelay: `${i * 0.15}s` }}
            >
              <div className={styles.stepIcon}>{step.icon}</div>
              <div className={`${styles.stepNumber} ${isVisible ? styles.stepNumberVisible : ''}`}>
                {step.number}
              </div>
              <h4 className={styles.stepTitle}>{step.title}</h4>
              <p className={styles.stepText}>{step.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
